import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=ad7d4034&scoped=true"
import script from "./SelectGroup.ts?vue&type=script&lang=ts&external"
export * from "./SelectGroup.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=ad7d4034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7d4034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad7d4034')) {
      api.createRecord('ad7d4034', component.options)
    } else {
      api.reload('ad7d4034', component.options)
    }
    module.hot.accept("./SelectGroup.vue?vue&type=template&id=ad7d4034&scoped=true", function () {
      api.rerender('ad7d4034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/pages/SelectGroup/SelectGroup.vue"
export default component.exports